export const STORAGE_KEYS = {
  token: "token",
  lastURL: "lastURL",
  user: "user",
  email: "email",
  userId: "userId",
  prodURL: "productUrl",
};
